const livePageStore = {
    namespaced: true,
    state: {
        theatreMode: false,
        sheet: false,
    },
    getters: {
        isPollVisible(state, getters, rootState, rootGetters) {
            return rootGetters['qld-vuex-store/property']('controller-toggle', 'polls', 'visible');
        },
        isChatVisible(state, getters, rootState, rootGetters) {
            return rootGetters['qld-vuex-store/property']('controller-toggle', 'livechat', 'visible');
        },
        isQuestionsVisible(state, getters, rootState, rootGetters) {
            return rootGetters['qld-vuex-store/property']('controller-toggle', 'question', 'visible');
        },
        isHandoutVisible(state, getters, rootState, rootGetters) {
            return rootGetters['qld-vuex-store/property']('controller-toggle', 'handouts', 'visible');
        },
        isQuizVisible(state, getters, rootState, rootGetters) {
            return rootGetters['qld-vuex-store/property']('controller-toggle', 'quiz', 'visible');
        },        
    },
    mutations: {
        openSheet(state) {
            state.sheet = true;
            setTimeout(() => {
                if (!window.QuadiaPlayer) {
                    return;
                }
                for (const playerInstanceID in window.QuadiaPlayer.players) {
                    try {
                        window.QuadiaPlayer.players[playerInstanceID].$emit(
                            'closeTheaterMode'
                        );
                    } catch {
                        // in case LD's player components shows an Image, where is no player to communicate to
                        state.theatreMode = false;
                    }
                }
            }, 200);
        },
        closeSheet(state) {
            state.sheet = false;
        },
        setTheatreMode(state, value) {
            state.theatreMode = value;
        }
    }
};

export default livePageStore;
